import { Product2Schema } from "@redotech/redo-model/inventory/inventory";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getProductById = unaryRpc({
  name: "getProductById",
  input: z.object({ productId: z.string() }),
  output: Product2Schema,
});
